var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_645_1194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1C11.866 1 15 4.13401 15 8H8V1Z",
    fill: "#FFB327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0998 2.86266C11.5893 1.35221 9.58594 0.520056 7.44968 0.520056C7.2155 0.520056 7.03509 0.710332 7.03509 0.940056V1.9507C3.60271 2.16806 0.86875 5.0303 0.86875 8.51817C0.86875 12.1469 3.81807 15.0991 7.44696 15.0991C9.20725 15.0991 10.8581 14.4236 12.0968 13.2026C13.2566 12.0595 13.929 10.5527 14.0152 8.93199H15.0224C15.2531 8.93199 15.4424 8.74833 15.4424 8.5151C15.4424 6.37884 14.6102 4.37313 13.0998 2.86266ZM11.5058 12.6044C10.4254 13.6693 8.98336 14.2575 7.44427 14.2575C4.27893 14.2575 1.70878 11.6829 1.70878 8.5174C1.70875 5.49341 4.06513 3.00847 7.03509 2.79271V8.51817C7.03509 8.74816 7.21036 8.93199 7.44427 8.93199H13.1741C13.089 10.3379 12.5046 11.6199 11.5058 12.6044ZM7.87509 8.09199V1.37217C9.60465 1.47322 11.2591 2.20141 12.5112 3.45352C13.7639 4.70622 14.4898 6.33289 14.5904 8.09199H7.87509Z",
    fill: "#474747",
    stroke: "#474747",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_645_1194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pieChart.d40ecc9a6d5c1668d0d9c4c01837d80c.svg";
export { ForwardRef as ReactComponent };